import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=5a66539a"
import script from "./SearchArea.vue?vue&type=script&lang=js"
export * from "./SearchArea.vue?vue&type=script&lang=js"
import style0 from "./SearchArea.vue?vue&type=style&index=0&id=5a66539a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports